import React from 'react';

export default function LoadingScreen({ isFullScreen = true }) {
    return (
        <div
            className={
                isFullScreen
                    ? "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#F7F3EC] transition-all duration-500"
                    : "bg-[#FCFAF8] border border-[#EEF1EC] rounded-[40px] p-12 sm:p-16 flex flex-col items-center justify-center shadow-2xl max-w-xl mx-auto my-12 relative overflow-hidden"
            }
        >
            <div className="shipping-box-scene">
                {/* Shadow on the floor */}
                <div className="box-shadow" />

                {/* Animated Box Container */}
                <div className="box-container">

                    {/* Inside Back Wall */}
                    <div className="box-inside" />

                    {/* Golden Glow inside */}
                    <div className="box-glow" />

                    {/* Products Container */}
                    <div className="products-container">
                        {/* Food Container */}
                        <div className="product item-container">
                            <svg width="40" height="30" viewBox="0 0 40 30" fill="none">
                                <path d="M5,15 L35,15 L32,30 L8,30 Z" fill="#F4F1DE" stroke="#E0E1DD" strokeWidth="1" />
                                <path d="M2,15 L38,15 L35,0 L5,0 Z" fill="rgba(255,255,255,0.8)" stroke="#D4D4D4" strokeWidth="1" />
                            </svg>
                        </div>
                        {/* Paper Cup */}
                        <div className="product item-cup">
                            <svg width="24" height="36" viewBox="0 0 24 36" fill="none">
                                <path d="M4,10 L20,10 L17,36 L7,36 Z" fill="#FFFFFF" stroke="#E5E5E5" strokeWidth="1" />
                                <path d="M5,18 L19,18 L18,26 L6,26 Z" fill="#D4A373" />
                                <path d="M2,10 L22,10 L21,3 L3,3 Z" fill="#243126" />
                            </svg>
                        </div>
                        {/* Carry Bag */}
                        <div className="product item-bag">
                            <svg width="36" height="46" viewBox="0 0 36 46" fill="none">
                                <rect x="4" y="12" width="28" height="34" rx="2" fill="#C19A6B" stroke="#A67B5B" strokeWidth="1" />
                                <path d="M12,12 C12,4 24,4 24,12" stroke="#A67B5B" strokeWidth="2" strokeLinecap="round" />
                                <rect x="10" y="24" width="16" height="8" rx="1" fill="#2F5D50" opacity="0.85" />
                            </svg>
                        </div>
                        {/* Pizza Box */}
                        <div className="product item-pizza">
                            <svg width="50" height="25" viewBox="0 0 50 25" fill="none">
                                <path d="M0,10 L25,0 L50,10 L25,20 Z" fill="#FAEDCD" stroke="#D4A373" strokeWidth="1" />
                                <path d="M0,10 L25,20 L50,10 L50,15 L25,25 L0,15 Z" fill="#E9D8A6" stroke="#D4A373" strokeWidth="1" />
                            </svg>
                        </div>
                        {/* Wooden Cutlery */}
                        <div className="product item-cutlery">
                            <svg width="24" height="40" viewBox="0 0 24 40" fill="none">
                                <path d="M8,12 L8,40 M6,2 L6,12 M8,2 L8,12 M10,2 L10,12" stroke="#D4A373" strokeWidth="2" strokeLinecap="round" />
                                <path d="M5,12 C5,16 11,16 11,12" fill="none" stroke="#D4A373" strokeWidth="2" />
                                <path d="M16,16 L16,40" stroke="#CC9966" strokeWidth="2" strokeLinecap="round" />
                                <ellipse cx="16" cy="8" rx="4" ry="7" fill="#CC9966" />
                            </svg>
                        </div>
                        {/* Packaging Roll */}
                        <div className="product item-roll">
                            <svg width="24" height="40" viewBox="0 0 24 40" fill="none">
                                <rect x="2" y="6" width="20" height="28" fill="#D7D7C1" />
                                <ellipse cx="12" cy="6" rx="10" ry="4" fill="#B7B7A4" />
                                <ellipse cx="12" cy="6" rx="4" ry="1.5" fill="#555" />
                                <ellipse cx="12" cy="34" rx="10" ry="4" fill="#C5C5B1" />
                            </svg>
                        </div>
                    </div>

                    {/* Sparkles */}
                    <div className="sparkle sparkle-1">
                        <svg width="16" height="16" viewBox="0 0 16 16"><path d="M8,0 C8,4 12,8 16,8 C12,8 8,12 8,16 C8,12 4,8 0,8 C4,8 8,4 8,0 Z" fill="#FACC15" /></svg>
                    </div>
                    <div className="sparkle sparkle-2">
                        <svg width="12" height="12" viewBox="0 0 16 16"><path d="M8,0 C8,4 12,8 16,8 C12,8 8,12 8,16 C8,12 4,8 0,8 C4,8 8,4 8,0 Z" fill="#FACC15" /></svg>
                    </div>
                    <div className="sparkle sparkle-3">
                        <svg width="20" height="20" viewBox="0 0 16 16"><path d="M8,0 C8,4 12,8 16,8 C12,8 8,12 8,16 C8,12 4,8 0,8 C4,8 8,4 8,0 Z" fill="#FFFFFF" /></svg>
                    </div>

                    {/* Front Wall */}
                    <div className="box-front">
                        <div className="box-tape" />
                        <div className="box-logo">
                            <img src="/logo.png" alt="ChefCo" className="h-16 w-auto max-w-[150px] object-contain drop-shadow-md" />
                        </div>
                    </div>

                    {/* Single Lid that falls off */}
                    <div className="box-flap-lid" />
                </div>
            </div>

            {/* Loading Text */}
            <p className="loading-text">
                Preparing your wholesale supplies...
            </p>

            {/* Embedded CSS Animations */}
            <style>{`
                .shipping-box-scene {
                    position: relative;
                    width: 240px;
                    height: 240px;
                    margin-bottom: 24px;
                }

                .box-container {
                    position: absolute;
                    bottom: 30px;
                    left: 50%;
                    margin-left: -60px;
                    width: 120px;
                    height: 100px;
                    animation: box-sequence 4s cubic-bezier(0.34, 1.56, 0.64, 1) infinite;
                }

                .box-shadow {
                    position: absolute;
                    bottom: 15px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 140px;
                    height: 20px;
                    background: radial-gradient(ellipse at center, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0) 70%);
                    animation: shadow-sequence 4s ease-in-out infinite;
                }

                .box-inside {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 120px;
                    height: 100px;
                    background-color: #8B5A2B;
                    border-radius: 4px;
                    z-index: 1;
                }

                .box-front {
                    position: absolute;
                    top: 20px;
                    left: 0;
                    width: 120px;
                    height: 80px;
                    background-color: #C19A6B;
                    z-index: 10;
                    border-radius: 0 0 4px 4px;
                    box-shadow: inset 0 6px 12px rgba(0,0,0,0.06);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                .box-tape {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 24px;
                    height: 80px;
                    background-color: rgba(255,255,255,0.15);
                    border-left: 1px dashed rgba(0,0,0,0.05);
                    border-right: 1px dashed rgba(0,0,0,0.05);
                }

                .box-logo {
                    z-index: 2;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .box-flap-lid {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 120px;
                    height: 20px;
                    background-color: #D4A373;
                    transform-origin: 0% 100%;
                    border-radius: 2px 2px 0 0;
                    z-index: 12;
                    animation: flap-fall-side 4s ease-in-out infinite;
                }

                .products-container {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 5;
                }

                .product {
                    position: absolute;
                    bottom: 80px; /* Opening sits exactly 20px from top of 100px box */
                    left: 50%;
                    transform-origin: bottom center;
                    opacity: 0;
                }

                .item-container { animation: item-container 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }
                .item-cup { animation: item-cup 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }
                .item-bag { animation: item-bag 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }
                .item-pizza { animation: item-pizza 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }
                .item-cutlery { animation: item-cutlery 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }
                .item-roll { animation: item-roll 4s cubic-bezier(0.2, 0.8, 0.2, 1) infinite; }

                .box-glow {
                    position: absolute;
                    top: -20px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 140px;
                    height: 60px;
                    background: radial-gradient(ellipse at bottom, rgba(255, 215, 0, 0.6) 0%, rgba(255, 215, 0, 0) 70%);
                    z-index: 6;
                    opacity: 0;
                    pointer-events: none;
                    animation: glow-fade 4s ease-in-out infinite;
                }

                .sparkle {
                    position: absolute;
                    z-index: 15;
                    opacity: 0;
                }
                .sparkle-1 { top: -30px; left: -10px; animation: sparkle-anim 4s ease-in-out infinite 0.9s; }
                .sparkle-2 { top: -70px; left: 110px; animation: sparkle-anim 4s ease-in-out infinite 1.1s; }
                .sparkle-3 { top: -10px; left: 130px; animation: sparkle-anim 4s ease-in-out infinite 1.3s; }

                .loading-text {
                    font-family: 'Inter', sans-serif;
                    color: #2F5D50;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: 0.03em;
                    margin: 0;
                    opacity: 0.9;
                    animation: text-pulse 4s ease-in-out infinite;
                }

                @keyframes box-sequence {
                    0% { transform: translateY(-250px) scale(0.9); opacity: 0; }
                    12% { transform: translateY(10px) scale(1.02); opacity: 1; }
                    16% { transform: translateY(-5px) scale(1); opacity: 1; }
                    20%, 80% { transform: translateY(0) scale(1); opacity: 1; }
                    86% { transform: translateY(15px) scale(1.05); opacity: 1; }
                    94%, 100% { transform: translateY(250px) scale(0.9); opacity: 0; }
                }

                @keyframes shadow-sequence {
                    0%, 5% { transform: translateX(-50%) scale(0); opacity: 0; }
                    12% { transform: translateX(-50%) scale(1.1); opacity: 0.3; }
                    16%, 80% { transform: translateX(-50%) scale(1); opacity: 0.15; }
                    86% { transform: translateX(-50%) scale(1.2); opacity: 0.3; }
                    94%, 100% { transform: translateX(-50%) scale(0); opacity: 0; }
                }

                @keyframes flap-fall-side {
                    0%, 15% { transform: rotate(0deg); top: 0; left: 0; opacity: 1; }
                    22% { transform: rotate(-130deg); top: 0; left: 0; opacity: 1; }
                    30% { transform: rotate(-160deg); top: 30px; left: -20px; opacity: 1; }
                    45% { transform: rotate(-220deg); top: 120px; left: -40px; opacity: 0; }
                    50%, 99% { transform: rotate(-220deg); top: 120px; left: -40px; opacity: 0; }
                    100% { transform: rotate(0deg); top: 0; left: 0; opacity: 1; }
                }

                @keyframes glow-fade {
                    0%, 25% { opacity: 0; }
                    35%, 65% { opacity: 1; }
                    75%, 100% { opacity: 0; }
                }

                @keyframes sparkle-anim {
                    0%, 25% { opacity: 0; transform: scale(0) rotate(0); }
                    30% { opacity: 1; transform: scale(1) rotate(45deg); }
                    35% { opacity: 0; transform: scale(0) rotate(90deg); }
                    100% { opacity: 0; }
                }

                @keyframes item-container {
                    0%, 26% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    34% { transform: translate(calc(-50% - 90px), -30px) scale(1) rotate(-35deg); opacity: 1; }
                    62% { transform: translate(calc(-50% - 95px), -35px) scale(1) rotate(-32deg); opacity: 1; }
                    70%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes item-cup {
                    0%, 23% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    31% { transform: translate(calc(-50% - 50px), -70px) scale(1) rotate(-15deg); opacity: 1; }
                    59% { transform: translate(calc(-50% - 55px), -75px) scale(1) rotate(-12deg); opacity: 1; }
                    67%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes item-bag {
                    0%, 22% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    30% { transform: translate(-50%, -100px) scale(1) rotate(5deg); opacity: 1; }
                    58% { transform: translate(-50%, -105px) scale(1) rotate(2deg); opacity: 1; }
                    66%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes item-pizza {
                    0%, 25% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    33% { transform: translate(calc(-50% + 55px), -65px) scale(1.1) rotate(20deg); opacity: 1; }
                    61% { transform: translate(calc(-50% + 60px), -70px) scale(1.1) rotate(23deg); opacity: 1; }
                    69%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes item-cutlery {
                    0%, 27% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    35% { transform: translate(calc(-50% + 95px), -25px) scale(1) rotate(40deg); opacity: 1; }
                    63% { transform: translate(calc(-50% + 100px), -30px) scale(1) rotate(43deg); opacity: 1; }
                    71%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes item-roll {
                    0%, 24% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                    32% { transform: translate(calc(-50% + 35px), -105px) scale(0.9) rotate(15deg); opacity: 1; }
                    60% { transform: translate(calc(-50% + 35px), -110px) scale(0.9) rotate(18deg); opacity: 1; }
                    68%, 100% { transform: translate(-50%, 0) scale(0); opacity: 0; }
                }

                @keyframes text-pulse {
                    0%, 100% { opacity: 0.6; }
                    50% { opacity: 1; }
                }
            `}</style>
        </div>
    );
}
